import { useSelector } from "react-redux";
import i18next from "i18next";
import { getIsVipRibbonHidden } from "redux/system/selectors";
export default () => {
	const isVipRiboonHidden = useSelector(getIsVipRibbonHidden);
	return !isVipRiboonHidden && <div className="vip1" data-vip={i18next.t("GOLD")}></div>;
};
